/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-participant-outcome.reducer';

export const TumorBoardParticipantOutcomeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardParticipantOutcomeEntity = useAppSelector(state => state.tumorBoardParticipantOutcome.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardParticipantOutcomeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.detail.title">TumorBoardParticipantOutcome</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.id}</dd>
          <dt>
            <span id="joinedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.joinedAt">Joined At</Translate>
            </span>
            <UncontrolledTooltip target="joinedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.joinedAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.joinedAt}</dd>
          <dt>
            <span id="leftAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.leftAt">Left At</Translate>
            </span>
            <UncontrolledTooltip target="leftAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.leftAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.leftAt}</dd>
          <dt>
            <span id="memberId">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.memberId">Member Id</Translate>
            </span>
            <UncontrolledTooltip target="memberId">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.memberId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.memberId}</dd>
          <dt>
            <span id="memberRole">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.memberRole">Member Role</Translate>
            </span>
            <UncontrolledTooltip target="memberRole">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.memberRole" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.memberRole}</dd>
          <dt>
            <span id="skipped">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.skipped">Skipped</Translate>
            </span>
            <UncontrolledTooltip target="skipped">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.skipped" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.skipped ? 'true' : 'false'}</dd>
          <dt>
            <span id="opinionSummary">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.opinionSummary">Opinion Summary</Translate>
            </span>
            <UncontrolledTooltip target="opinionSummary">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.opinionSummary" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.opinionSummary}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.boardMember">Board Member</Translate>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.boardMember ? tumorBoardParticipantOutcomeEntity.boardMember.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.occurrence">Occurrence</Translate>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.occurrence ? tumorBoardParticipantOutcomeEntity.occurrence.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.patient">Patient</Translate>
          </dt>
          <dd>{tumorBoardParticipantOutcomeEntity.patient ? tumorBoardParticipantOutcomeEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-participant-outcome" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board-participant-outcome/${tumorBoardParticipantOutcomeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardParticipantOutcomeDetail;
